<template>
  <div class="recommend-course-box max-width-box">
    <div class="course-list-box list-container">
      <div
        class="course-item"
        v-for="(item, index) in courseList"
        :key="index"
        @click="gotoDetail(item.id)"
      >
        <div class="course-item-content">
          <div class="avatar">
            <el-carousel
              trigger="click"
              :height="screenwidth"
              :autoplay="false"
              indicator-position="none"
            >
              <el-carousel-item
                v-for="(img, index) in item.courseImg"
                :key="index"
                :style="{ 'background-image': 'url(' + img + ')' }"
              >
              </el-carousel-item>
            </el-carousel>

            <!-- <img :src="item.courseImg" /> -->
            <div class="name-box">
              <div class="name">{{ item.courseName }}</div>
              <!-- <div class="adress">{{ item.covey_user.realname }}</div> -->
            </div>
          </div>
          <div class="bottom">
            <div class="teacher-avatar-box">
              <div style="line-height: 24px">
                <el-image :src="item.covey_user ? item.covey_user.photo : ''">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <span
                  :title="item.covey_user ? item.covey_user.realname : ''"
                  >{{ item.covey_user ? item.covey_user.realname : "" }}</span
                >
              </div>
              <el-tooltip
                v-if="item.covey_group"
                class="item"
                effect="dark"
                :content="item.covey_group.societyName"
                placement="top"
              >
                <img src="@/assets/icon/organization.svg" />
              </el-tooltip>
            </div>
            <div class="describe">
              {{ item.courseDesc }}
            </div>
            <div class="split-line"></div>
            <div class="price">
              <div class="price-num">
                <span>Price:</span>
                <span>C${{ (item.price / 100).toFixed(2) }}/h</span>
              </div>
              <!-- <div class="middle-star">
                <img :src="require('@/assets/icon/star.png')" />
                <span>{{ item.avgscore }}</span>
                <span
                  class="reviews ellipsis1"
                  :title="item.evaluationtimes + ' Reviews'"
                  >({{ item.evaluationtimes }})</span
                >
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "recommend-courses",
  props: ["courseList"],

  data() {
    return {
      screenwidth: "",
    };
  },
  mounted() {
    this.initCourseImgWidth();
    window.onresize = () => {
      this.initCourseImgWidth();
    };
  },

  created() {
    // this.getRecommendCourses();
  },
  methods: {
    initCourseImgWidth() {
      let screenWidth = document.body.clientWidth;
      let set_width = 200;
      if (screenWidth > 1800) {
        this.screenwidth = "200px";
        return;
      } else if (screenWidth > 1760 && screenWidth <= 1800) {
        set_width = 200;
      } else if (screenWidth > 1600 && screenWidth <= 1760) {
        set_width = 200;
      } else if (screenWidth > 1160 && screenWidth <= 1600) {
        set_width = 300;
      } else if (screenWidth > 900 && screenWidth <= 1160) {
        set_width = 400;
      } else if (screenWidth > 600 && screenWidth <= 900) {
        set_width = 450;
      } else if (screenWidth <= 600) {
        set_width = 1000;
      }
      this.screenwidth =
        (document.documentElement.clientWidth * set_width) / 2048 + "px";
    },
    gotoDetail(id) {
      if (!this.$route.fullPath.includes("/course")) {
        this.$router.push({ path: "/course", query: { courseId: id } });
      } else {
        this.$router.push({
          path: this.$route.fullPath,
          query: { courseId: id },
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/utils/vw.scss";
.recommend-course-box {
  height: auto;
  padding: 0 16px 32px;
  // max-width: 1400px;
  margin: auto;
  .list-container {
    display: grid;
  }
  .course-list-box {
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 16px;

    .course-item {
      width: 100%;
      min-width: 245px;
    }
    .course-item-content {
      box-sizing: border-box;
      background: #fff;
      box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
      cursor: pointer;
      &:hover {
        .describe {
          color: #f48c06;
        }
      }
      .avatar {
        position: relative;
        width: 100%;
        .el-carousel {
          overflow: hidden;
          .el-carousel-item {
            width: 100%;
            height: 0;
            padding-bottom: 100%;
            overflow: hidden;

            background-position: center center;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            background-size: cover;
          }
        }
        .el-carousel__item {
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 100%;
          transition: 0.5s;
          &:hover {
            background-size: 120%;
          }
        }
        .name-box {
          position: absolute;
          bottom: 0px;
          left: 0px;
          width: 100%;
          padding: 0 10px;
          box-sizing: border-box;
          color: #ffffff;
          font-weight: 600;
          line-height: 40px;
          z-index: 4;
          background: #8f8f8fde;
          .name {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            font-size: 20px;
          }
          .adress {
            font-size: 16px;
          }
        }
      }
      .bottom {
        padding: 0 20px 14px;
      }
      .describe {
        min-height: 48px;
        line-height: 24px;
        font-size: 16px;
        color: #0a033c;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        transition: 0.3s;
      }
      .teacher-avatar-box {
        height: 54px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
          margin-left: 8px;
          font-size: 14px;
          vertical-align: top;
        }
        img {
          width: 24px;
          height: 24px;
          border-radius: 50%;
        }
        .el-image {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          .el-icon-picture-outline {
            font-size: 16px;
          }
        }
      }
      .split-line {
        height: 1px;
        background: #201002;
        opacity: 0.16;
        margin-top: 16px;
      }
      .price {
        height: 24px;
        margin-top: 12px;
        line-height: 24px;
        color: #201002;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        .price-num {
          span:nth-child(1) {
            font-size: 15px;
          }
        }
        span:nth-child(2) {
          margin-left: 4px;
          color: #f48c06;
        }

        .reviews {
          color: #a6a6a6;
        }
        .middle-star {
          display: flex;
          align-items: center;
          img {
            width: 14px;
            height: 14px;
          }
        }
      }
    }
  }
}
</style>